import { serializeTimeMinutes } from "@/lib/date";

export type ResolveLeaveRequestTimesError =
    | "timeRequired"
    | "timeToRequiresDateTo"
    | "timeOrder";

export type ResolveLeaveRequestTimesResult =
    | { ok: true; timeFrom: string | null; timeTo: string | null }
    | { ok: false; error: ResolveLeaveRequestTimesError };

export type LeaveAbsenceMode = "all" | "arrives" | "leaves" | "part";

type ResolveLeaveRequestTimesArgs = {
    absenceMode: LeaveAbsenceMode;
    timeFrom: string;
    timeTo: string;
};

/**
 * Validates the time fields for a leave request.
 */
export function resolveLeaveRequestTimes({
    absenceMode,
    timeFrom,
    timeTo,
}: ResolveLeaveRequestTimesArgs): ResolveLeaveRequestTimesResult {
    // all-day absence returns nulls
    if (absenceMode === "all") {
        return { ok: true, timeFrom: null, timeTo: null };
    }

    const serializedFrom = serializeTimeMinutes(timeFrom);
    const serializedTo = serializeTimeMinutes(timeTo);

    // checks if the timeTo is required
    if (absenceMode === "arrives" && serializedTo == null) {
        return { ok: false, error: "timeRequired" };
    }

    // checks if the timeFrom is required
    if (absenceMode === "leaves" && serializedFrom == null) {
        return { ok: false, error: "timeRequired" };
    }

    // checks if the timeFrom is before the timeTo
    // for part-day absence
    if (
        absenceMode === "part" &&
        serializedFrom != null &&
        serializedTo != null &&
        serializedFrom >= serializedTo
    ) {
        return { ok: false, error: "timeOrder" };
    }

    // if all checks pass, return the serialized times
    return { ok: true, timeFrom: serializedFrom, timeTo: serializedTo };
}
